import React, { useRef, useState } from "react";
import { Button, FormControlLabel, FormGroup, Switch } from "@mui/material";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { FormControl, Input, InputLabel } from "@mui/material";

const CompanyAddModal = (props) => {
	
	const companyName = useRef(null);
	const domain = useRef(null);
	const userName = useRef(null);
	const email = useRef(null);
	let [ companyBranding, setCompanyBranding ] = useState(false);
	
	const handleClose = () => {
		props.onClose()
	};
	
	const handleSubmit = () => {
		const company = {
			name: companyName.current.value,
			domain: domain.current.value,
			company_branding: companyBranding
		};
		const user = {
			name: userName.current.value,
			email: email.current.value
		}
		props.onSubmit(company, user);
	};
	
	const handleSubmitForm = (e) => {
		e.preventDefault();
		handleSubmit();
	};
	
	const handleCancel = () => {
		props.onClose()
	};
	
	const handleCompanyBrandingSwitch = (event) => {
		setCompanyBranding(event.target.checked);
	}
	
	const formControlStyle = {
		width: "80%",
		maxWidth: "35em",
		margin: "1em 10%"
	};
	
	return (
		<Dialog
			open={props.open}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			fullWidth={true}
		>
			<DialogTitle id="alert-dialog-title">
				Add Company
			</DialogTitle>
			<DialogContent>
				<form onSubmit={handleSubmitForm} autoComplete="off">
					<FormControl sx={formControlStyle}>
						<InputLabel htmlFor="companyName">Company Name</InputLabel>
						<Input inputRef={companyName} id="companyName"/>
					</FormControl>
					<FormControl sx={formControlStyle}>
						<InputLabel htmlFor="domain">Domain</InputLabel>
						<Input inputRef={domain} id="domain"/>
					</FormControl>
					<FormControl sx={formControlStyle}>
						<InputLabel htmlFor="userName">User Name</InputLabel>
						<Input inputRef={userName} id="userName"/>
					</FormControl>
					<FormControl sx={formControlStyle}>
						<InputLabel htmlFor="email">Email</InputLabel>
						<Input inputRef={email} id="email"/>
					</FormControl>
					<FormGroup sx={formControlStyle}>
						<FormControlLabel
							control={
								<Switch
									checked={companyBranding}
									onChange={handleCompanyBrandingSwitch}
								/>
							}
							label="Enable Custom Branding"
						/>
					</FormGroup>
				</form>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleCancel}>Cancel</Button>
				<Button onClick={handleSubmit} autoFocus>Submit</Button>
			</DialogActions>
		</Dialog>
	);
};

export default CompanyAddModal;